// extracted by mini-css-extract-plugin
export var mainMenuContainer = "MainMenu_mainMenuContainer__u8sFI";